import { useEffect, useId, useState } from 'react'
import { Icon } from './Icon'

export function QuantityInput({ value, min = 1, max, onChange, disabled, label = 'Cantidad' }: { value: number; min?: number; max: number; onChange: (value: number) => void; disabled?: boolean; label?: string }) {
  const id = useId()
  const [draft, setDraft] = useState(String(value))
  useEffect(() => setDraft(String(value)), [value])
  const minimum = Math.max(0, Math.floor(min))
  const limit = Math.max(minimum, Math.floor(max))
  function commit() {
    const parsed = Math.floor(Number(draft))
    const next = Math.min(limit, Math.max(minimum, Number.isFinite(parsed) ? parsed : minimum))
    setDraft(String(next))
    if (next !== value) onChange(next)
  }
  return <div className="quantity-field">
    <label className="sr-only" htmlFor={id}>{label}</label>
    <button className="icon-button" type="button" aria-label={`Reducir ${label.toLowerCase()}`} disabled={disabled || value <= minimum} onClick={() => onChange(value - 1)}><Icon name="minus" size={16} /></button>
    <input id={id} type="text" inputMode="numeric" value={draft} disabled={disabled} onChange={(event) => setDraft(event.target.value)} onBlur={commit}
      onKeyDown={(event) => { if (event.key === 'Enter' && !event.nativeEvent.isComposing) { event.preventDefault(); commit() } }} />
    <button className="icon-button" type="button" aria-label={`Aumentar ${label.toLowerCase()}`} disabled={disabled || value >= limit} onClick={() => onChange(value + 1)}><Icon name="plus" size={16} /></button>
  </div>
}
